import { BuiltInComponents } from 'craft/constants';
import { useFindAncestorWithType } from 'craft/hooks/useFindAncestorWithType';

import { useFlow } from './useFlow';

export const useFlowAncestor = (
  nodeId?: string,
  flowTypes: string[] = [BuiltInComponents.Flow],
) => {
  const flowNodeId = useFindAncestorWithType(nodeId, flowTypes);

  const flow = useFlow(flowNodeId);

  if (!flowNodeId) {
    return { isInFlow: false, ...flow, flowNodeId };
  }

  return {
    isInFlow: true,
    ...flow,
    flowNodeId,
  };
};
